module.exports = {
      id: "lifestyle-usage",
      viewBox: "0 0 24.217 32.155",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#lifestyle",
      toString: function () {
        return this.url;
      }
    }